import {NgModule} from '@angular/core';
import {UserService} from './user.service';
import {UserImpersonationService} from './user-impersonation.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [UserService, UserImpersonationService]
})
export class UserModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/user/user.module.ts